<template>
  <section>
    <div class="content-wrapper">
      <errors v-if="isVisibleErrorsModal"></errors>
      <question v-if="display"></question>
      <div class="content-heading">
        All users
        <small data-localize="dashboard.WELCOME"></small>
      </div>

      <breadcrumb class="breadcrumb" v-bind:breadcrumbsData="breadcrumbData" />
      <br>

      <div class="row">
        <spinner v-if="loading"></spinner>
        <div class="col-lg-12">
          <div id="panelChart9" class="panel panel-default">
            <div class="panel-title">
              Redeem request
            </div>
            <div class="line-separator"></div>
            <div class="bottom-margin">
              <div class="row top-margin">
                <div class="col-md-3">
                  <div>
                    <label>Principal amount:</label>
                  </div>
                </div>
                <div class="col-md-3">
                  <div>
                    <p class="text-center">{{formatNegativeAmount(redeemNote.principalAmount)}}</p>
                  </div>
                </div>
                <div class="col-md-3">
                  <div>
                    <label>Interest due:</label>
                  </div>
                </div>
                <div class="col-md-2">
                  <div>
                    <p class="text-center">{{formatNegativeAmount(redeemNote.currentAccrintValue)}}</p>
                  </div>
                </div>
              </div>
              <div class="line-separator"></div>
              <form>
                <div class="row top-margin">
                  <div class="col-md-1">
                    <div>
                      <span>Full</span>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div v-bind:class="redeemNote.redeemFull ? 'radio-item' : 'radio-item radio-item-unselected'">
                      <input id="ritema" name="ritem" type="radio" @change="resetRadioValue()" v-bind:value="true" v-bind:disabled="!redeemNote.isNewRedemption" v-model="redeemNote.redeemFull" />
                      <label for="ritema"></label>
                    </div>
                  </div>
                  <div class="col-md-1">
                    <div>
                      <span>Partial</span>
                    </div>
                  </div>
                  <div class="col-md-1">
                    <div v-bind:class="!redeemNote.redeemFull ? 'radio-item' : 'radio-item radio-item-unselected'">
                      <input id="ritemb" name="ritem" type="radio" @change="resetRadioValue()" v-bind:value="false" v-bind:disabled="!redeemNote.isNewRedemption" v-model="redeemNote.redeemFull" />
                      <label for="ritemb"></label>
                    </div>
                  </div>
                </div>
              </form>
              <div class="space" />
              <div class="row top-margin">
                <div class="col-md-3">
                  <div>
                    <label>Bank account *</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div>
                    <select name="FundingSource" v-model="redeemNote.fundingSource" id="FundingSource" class="form-control" placeholder="Please select" v-bind:disabled="!redeemNote.isNewRedemption">
                        <option v-for="fs in redeemNote.fundingSources" :value="fs.id" :key="fs.id">{{fs.name}}</option>
                        <option :value="donateFundingSource.name">{{ donateFundingSource.text }}</option>
                      </select>
                  </div>
                  <p class="top-margin" style="color: red;" v-if="!this.redeemNote.fundingSource || !this.redeemNote.fundingSources || this.redeemNote.fundingSources.length === 0"><i>There must be a valid bank account for the redemption.</i></p>
                </div>
              </div>
              <div class="space" />
              <div class="row top-margin">
                <div class="col-md-4">
                  <div>
                    <label>Principal to redeem: *</label>
                  </div>
                </div>
                <div class="col-md-2">
                  <div>
                    <p v-if="redeemNote.redeemFull" class="text-right">{{formatNegativeAmount(getUnformattedValue(redeemNote.redeemAmount))}}</p>
                    <input v-if="!redeemNote.redeemFull" v-on:change="removeNegative" v-money="money" v-model="redeemNote.redeemAmount" id="redeemPartialAmount" autocomplete="off" required class="form-control text-right" v-bind:disabled="!redeemNote.isNewRedemption">
                  </div>
                </div>
              </div>
              <p class="top-margin" style="color: red;" v-if="checkRemainingPrincipalAmount()"><i>Please change this redemption request to ensure the remaining principal on the note is $20 or more.</i></p>
              <div class="row top-margin">
                <div class="col-md-4">
                  <div>
                    <label>Service fee:</label>
                  </div>
                </div>
                <div class="col-md-2">
                  <div>
                    <input v-on:change="removeNegative" v-money="money" v-model="redeemNote.serviceFee" id="serviceFee" autocomplete="off" required class="form-control text-right">
                  </div>
                </div>
              </div>
              <div class="row top-margin">
                <div class="col-md-4">
                  <div>
                    <label>Principal to repay:</label>
                  </div>
                </div>
                <div class="col-md-2">
                  <div>
                    <p class="text-right total-amount">{{getPrincipalToRepay()}}</p>
                  </div>
                </div>
              </div>
              <div class="line-separator2" ></div>
              <div class="row top-margin mb-lg">
                <div class="col-md-4">
                  <div>
                    <label class="mt-sm pt-sm">Interest payment:</label>
                  </div>
                </div>
                <div class="col-md-2">
                  <div>
                    <p v-if="redeemNote.redeemFull" class="text-right">{{formatNegativeAmount(redeemNote.currentAccrintValue)}}</p>
                    <input v-if="!redeemNote.redeemFull" v-on:change="removeNegative"
                      v-money="money" v-model="redeemNote.interestToReedem"
                      id="interestAmount" autocomplete="off" required
                      :class="{ 'form-control text-right': true, 'form-control-error': getUnformattedValue(redeemNote.interestToReedem)  > getUnformattedValue(redeemNote.currentAccrintValue) }"
                      v-bind:disabled="!redeemNote.isNewRedemption">

                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <p class="top-margin" style="color: red;" v-if="getUnformattedValue(redeemNote.interestToReedem)  > getUnformattedValue(redeemNote.currentAccrintValue)"><i>The interest payment cannot be greater than the accrued interest</i></p>
                </div>
              </div>
              <div class="line-separator2"></div>
              <div class="row top-margin">
                <div class="col-md-4">
                  <div>
                    <label>Total paid to investor:</label>
                  </div>
                </div>
                <div class="col-md-2">
                  <div>
                    <p class="text-right total-amount">{{getTotalPaidOut()}}</p>
                  </div>
                </div>
              </div>
              <div class="row top-margin">
                <div class="col-md-3">
                  <div>
                    <label>Redemption Category *</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div>
                    <select
                      name="RedemptionCategory"
                      v-model="redeemNote.redemptionCategoryId"
                      id="RedemptionCategory"
                      class="form-control"
                      placeholder="Please select"
                    >
                      <option
                        v-for="rc in redeemNote.redemptionCategories"
                        :value="rc.id"
                        :key="rc.id"
                      >
                        {{ rc.label }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row" v-if="displayRedemptionCategoryHelperText">
                <div class="col-md-6">
                  <input
                    v-model.trim="redeemNote.redemptionCategoryHelperText"
                    id="redemptionCategoryHelperText"
                    autocomplete="off"
                    placeholder="Enter a redemption category..."
                    required
                    class="form-control"
                  />
                </div>
              </div>
              <p class="top-margin" style="color: red;" v-if="redeemNote.redeemFull && this.totalPaidOut <= 0"><i>Please ensure the total paid out is more than $0.</i></p>
              <p class="top-margin" style="color: red;" v-if="displayPaidOutError(redeemNote.redeemFull)">
                <i>Please change this redemption request to ensure the total paid out and Principal to repay is more than $0.</i>
              </p>
              <p class="top-margin" style="color: red;" v-if="!redeemNote.isNewRedemption && !this.noteHasSufficientFunds"><i>There are insufficient funds on this note to pay these transactions. Please edit the redemption values before approving payment.</i></p>
              <div class="row top-margin">
                <div class="col-md-12">
                  <span>Please append your comment below *</span>
                  <restricted-textarea
                  :input="redeemNote.comment"
                  :limit="255"
                  id="comment"
                  :required="true"
                  placeholder=""
                  @inputUpdated="commentUpdated"
                />
                  <p class="top-margin" style="color: red;" v-if="!redeemNote.comment || initialComment === redeemNote.comment"><i>You must enter or append a comment.</i></p>
                </div>
              </div>
              <div class="row top-margin" v-if="!disableApprove">
                <div class="col-md-10">
                  <div class="alert alert-info tip-alert">
                    <i class="fa fa-info-circle"></i>
                    All transactions must be entered by <strong>4:55 p.m. ET</strong> to be processed today.
                  </div>
                </div>
              </div>
              <div class="row top-margin">
                <div class="col-md-10">
                  <button type="submit" class="btn btn-info btn-lg button-white buttons" v-on:click="redeemNote.isNewRedemption ? goBack() : showRedeemConfirmationModal()" v-bind:disabled="!redeemNote.isNewRedemption && isCancelButtonDisabled()">Cancel request</button>
                  <button type="submit" class="btn btn-info btn-lg button-white buttons" v-on:click="approveRedemption" v-bind:disabled="disableApprove">Approve payment</button>
                  <button type="submit" class="btn btn-info btn-lg button-approve buttons" v-on:click="submitRequest" v-bind:disabled="disableSubmit">Submit request</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import {
    mapActions,
    mapMutations,
    mapState,
  } from 'vuex';

  import Errors from '@/components/modals/Errors';
  import {
    VMoney,
  } from 'v-money';

  import {
    SET_ERRORS_MODAL_INFO,
    SHOW_ERRORS_MODAL,
    HIDE_QUESTION_MODAL,
    SHOW_QUESTION_MODAL,
  } from '@/store/mutation-types';

  import {
    formatDecimal,
    formatNegativeAmount,
    getAccounTypeProperties,
  } from '@/util';
  import spinner from '@/components/widgets/Spinner';
  import Question from '@/components/modals/Question';
  import breadcrumb from '@/components/Breadcrumb';
  import { UserTypes } from '@/data/static/userTypes';
  import Actions from '@/data/static/upcomingTransactionActions';
  import RestrictedTextArea from '@/components/formControls/RestrictedTextArea';

  import {
    Constants,
  } from '../data/static/constants';

  const mix = {
    methods: {
      formatDecimal,
      formatNegativeAmount,
    },
  };

  export default {
    name: 'redeem',
    beforeMount() {
      this.setParams();
      this.loadRedeemNote();
    },
    mixins: [mix],
    components: {
      errors: Errors,
      spinner,
      question: Question,
      breadcrumb,
      'restricted-textarea': RestrictedTextArea,
    },
    watch: {
      redeemNote: async function changeNote(newRedeemNote) {
        const { accountName, accountType, id: accountId } = newRedeemNote.account;
        const users = await this.getAccountUsers(this.accountId);
        this.breadcrumbData = [];
        this.breadcrumbData.push(
          Object.assign({}, {
            title: 'Search',
            goto: { name: 'Users' },
            selected: false,
          }),
        );
        const params = Object.assign({}, this.$route.params);
        const user = users.find(search => search.id === Number(params.userId));
        const { userType, firstName, lastName } = user;
        let goto;
        if (userType === UserTypes.FINANCIAL_ADVISOR.name) {
          goto = {
            name: 'EditFinancialAdvisor',
            params: {
              name: params.name,
              userId: params.userId,
            },
          };
        } else {
          goto = { name: 'UserDetail', params: { name: params.name, userId: params.userId } };
        }
        this.breadcrumbData.push(
          Object.assign({}, {
            goto,
            title: firstName.concat(' ', lastName),
            selected: false,
          }),
        );
        const accountTypeProperties = getAccounTypeProperties(accountType);
        const gotoAccount = {
          name: accountTypeProperties.component,
          params: {
            accountId,
            name: params.name,
            userId: params.userId,
          },
        };
        this.breadcrumbData.push(
          Object.assign({}, {
            title: accountName,
            goto: gotoAccount,
            selected: false,
          }),
        );
        this.breadcrumbData.push(
          Object.assign({}, {
            title: 'Note'.concat(' ', newRedeemNote.noteId),
            goto: { name: 'NoteDetail', params: this.$route.params },
            selected: false,
          }),
        );
        this.breadcrumbData.push(
          Object.assign({}, {
            title: 'Redeem',
            goto: { name: this.$route.name, params: this.$route.params },
            selected: true,
          }),
        );
      },
    },
    data() {
      return {
        noteId: '',
        userId: '',
        name: '',
        accountId: '',
        breadcrumbData: [],
        redeemNote: {
          principalAmount: 0,
          interestToReedem: 0,
          currentAccrintValue: 0,
          serviceFee: 0,
          redeemAmount: 0,
          redemptionCategoryId: 0,
          redemptionCategoryHelperText: '',
          redemptionCategories: [],
        },
        initialComment: '',
        totalPaidOut: 0,
        loading: false,
        noteHasSufficientFunds: false,
        money: {
          decimal: '.',
          thousands: ',',
          prefix: '$',
          precision: 2,
        },
      };
    },
    computed: {
      ...mapState('errors', [
        'isVisibleErrorsModal',
      ]),
      ...mapState('question', [
        'display',
      ]),
      donateFundingSource() {
        return Actions.donate;
      },
      displayRedemptionCategoryHelperText() {
        const category = this.redeemNote.redemptionCategories.find(
          redemptionCategory =>
            redemptionCategory.id === this.redeemNote.redemptionCategoryId,
        ) || {};
        if (!category.needsHelperText) {
          this.redeemNote.redemptionCategoryHelperText = '';
        }
        return category.needsHelperText || false;
      },
      disableApprove() {
        return (
          this.redeemNote.isNewRedemption ||
          !this.noteHasSufficientFunds ||
          this.isButtonDisabled() ||
          (this.displayRedemptionCategoryHelperText &&
            this.redeemNote.redemptionCategoryHelperText === '')
        );
      },
      disableSubmit() {
        return (
          !this.redeemNote.isNewRedemption ||
          this.isButtonDisabled() ||
          (this.displayRedemptionCategoryHelperText &&
            this.redeemNote.redemptionCategoryHelperText === '')
        );
      },
    },
    directives: {
      money: VMoney,
    },
    methods: {
      commentUpdated($event) {
        this.redeemNote.comment = $event;
      },
      ...mapActions('note', [
        'getRedeemNote',
        'getAccountNoteRedeem',
        'validateRedemptionFunds',
        'requestNoteRedemption',
        'approveNoteRedemption',
        'cancelNoteRedemption',
      ]),
      ...mapActions('account', [
        'getAccountUsers',
      ]),
      ...mapMutations('question', {
        hideQuestionModal: HIDE_QUESTION_MODAL,
        showQuestionModal: SHOW_QUESTION_MODAL,
      }),
      ...mapMutations('errors', {
        showErrorsModal: SHOW_ERRORS_MODAL,
        setErrorsModalInfo: SET_ERRORS_MODAL_INFO,
      }),
      displayPaidOutError(redeemFull) {
        return !redeemFull &&
          (
            this.totalPaidOut <= 0 ||
            this.getUnformattedValue(this.redeemNote.redeemAmount) <= 0 ||
            this.getUnformattedValue(this.redeemNote.redeemAmount)
              <= this.getUnformattedValue(this.redeemNote.serviceFee)
          );
      },
      setParams() {
        this.name = this.$route.params.name;
        this.userId = this.$route.params.userId;
        this.noteId = this.$route.params.noteId;
        this.accountId = this.$route.params.accountId;
      },
      async validateRedeemFunds() {
        this.loading = true;
        return this.validateRedemptionFunds(this.noteId)
          .then(({ isValid }) => {
            this.noteHasSufficientFunds = isValid;
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
            if (err !== 'UNAUTHORIZED') {
              this.setErrorsModalInfo(['We could not validate the note\'s fund.']);
              this.showErrorsModal();
            }
          });
      },
      async loadRedeemNote() {
        this.loading = true;
        await this.getAccountNoteRedeem({
          noteId: this.noteId,
          accountId: this.accountId,
        })
        .then((redeemNote) => {
          this.redeemNote = redeemNote;
          this.redeemNote.principalAmount = formatDecimal(redeemNote.principalAmount);
          this.redeemNote.serviceFee = formatDecimal(redeemNote.serviceFee).toFixed(2);
          this.redeemNote.interestToReedem = this.redeemNote.redeemFull ?
              formatDecimal(this.redeemNote.currentAccrintValue).toFixed(2)
              : formatDecimal(this.redeemNote.interestToReedem).toFixed(2);
          this.redeemNote.redeemAmount = redeemNote.isNewRedemption ?
              formatDecimal(redeemNote.principalAmount).toFixed(2) :
              formatDecimal(redeemNote.redeemAmount).toFixed(2);

          this.redeemNote.fundingSources = redeemNote.fundingSources.filter(fundingSource => (
              (fundingSource.type === 'bank' || fundingSource.type === 'check' || fundingSource.type === 'wire/ach')
              && fundingSource.status === 'verified' && !fundingSource.removed));

          this.initialComment = redeemNote.comment;
          this.loading = false;
          if (!redeemNote.isNewRedemption) {
            this.validateRedeemFunds();
          }
        })
          .catch((err) => {
            this.loading = false;
            if (err !== 'UNAUTHORIZED') {
              this.setErrorsModalInfo(['We could not retrieve the redeem note details.']);
              this.showErrorsModal();
            }
          });
      },
      checkRemainingPrincipalAmount() {
        const redeemAmount = this.getUnformattedValue(this.redeemNote.redeemAmount);
        const remainingAmount = this.redeemNote.principalAmount - redeemAmount;
        if (!this.redeemNote.redeemFull && remainingAmount < 20) {
          return true;
        }
        return false;
      },
      removeNegative() {
        this.redeemNote.redeemAmount = this.redeemNote.redeemAmount.toString().replace('-', '');
        this.redeemNote.serviceFee = this.redeemNote.serviceFee.toString().replace('-', '');
        this.redeemNote.interestToReedem = this.redeemNote.interestToReedem.toString().replace('-', '');
      },
      resetRadioValue() {
        this.redeemNote.serviceFee = 0;
        if (this.redeemNote.redeemFull) {
          this.redeemNote.redeemAmount = this.redeemNote.principalAmount;
          this.redeemNote.interestToReedem = this.redeemNote.currentAccrintValue;
        } else {
          this.redeemNote.redeemAmount = 0;
          this.redeemNote.interestToReedem = 0;
        }
      },
      getUnformattedValue(value) {
        const unformattedValue = value.toString().replace('$', '').replace(/,/g, '');
        return this.formatDecimal(unformattedValue);
      },
      getTotalAmount() {
        const redeemAmount = this.getUnformattedValue(this.redeemNote.redeemAmount);
        const redeemInterest =
          this.formatDecimal(this.getUnformattedValue(this.redeemNote.interestToReedem));
        return redeemAmount + redeemInterest;
      },
      getTotalPaidOut() {
        const redeemAmount = this.getUnformattedValue(this.redeemNote.redeemAmount);
        const serviceFee = this.getUnformattedValue(this.redeemNote.serviceFee);
        const totalAmount = redeemAmount +
          this.formatDecimal(this.getUnformattedValue(this.redeemNote.interestToReedem));
        this.totalPaidOut = totalAmount - serviceFee;
        return formatNegativeAmount(this.totalPaidOut);
      },
      getPrincipalToRepay() {
        const redeemAmount = this.getUnformattedValue(this.redeemNote.redeemAmount);
        const serviceFee = this.getUnformattedValue(this.redeemNote.serviceFee);
        const amountToRepay = redeemAmount - serviceFee;
        return formatNegativeAmount(amountToRepay);
      },
      isCancelButtonDisabled() {
        if (!this.redeemNote.comment) {
          return true;
        }
        if (this.initialComment === this.redeemNote.comment) {
          return true;
        }
        return false;
      },
      currentFundingSourceExists() {
        if (!this.redeemNote.fundingSource) {
          return false;
        }

        const existingFundingSource = this.redeemNote.fundingSources.filter(fundingSource => (
          fundingSource.id.toString() === this.redeemNote.fundingSource.toString()));

        return existingFundingSource.length !== 0 || this.redeemNote.fundingSource === 'donate';
      },
      isButtonDisabled() {
        if (!this.redeemNote.comment) {
          return true;
        }
        if (this.initialComment === this.redeemNote.comment) {
          return true;
        }
        if (this.totalPaidOut <= 0) {
          return true;
        }
        const redeemAmount = this.getUnformattedValue(this.redeemNote.redeemAmount);
        const serviceFee = this.getUnformattedValue(this.redeemNote.serviceFee);
        const amountToRepay = redeemAmount - serviceFee;
        if (amountToRepay <= 0) {
          return true;
        }
        if (this.getUnformattedValue(this.redeemNote.redeemAmount) <= 0) {
          return true;
        }
        if (!this.redeemNote.fundingSources || !this.currentFundingSourceExists()) {
          return true;
        }
        if (this.checkRemainingPrincipalAmount()) {
          return true;
        }
        if (!this.redeemNote.redeemFull &&
        this.getUnformattedValue(this.redeemNote.interestToReedem) >
          this.getUnformattedValue(this.redeemNote.currentAccrintValue)) {
          return true;
        }
        return false;
      },
      getInterestToRedeem() {
        if (this.redeemNote.redeemFull) {
          return this.redeemNote.currentAccrintValue;
        } else if (!this.redeemNote.redeemFull &&
          this.redeemNote.interestToReedem === formatNegativeAmount(this.redeemNote.currentAccrintValue)) { // eslint-disable-line max-len
          return this.redeemNote.currentAccrintValue;
        }
        return this.getUnformattedValue(this.redeemNote.interestToReedem);
      },
      async submitRequest() {
        try {
          const redeemRequest = {
            isRedeemFull: this.redeemNote.redeemFull,
            amount: this.getUnformattedValue(this.redeemNote.redeemAmount),
            serviceFee: this.getUnformattedValue(this.redeemNote.serviceFee),
            comment: this.redeemNote.comment,
            fundingSourceId: this.redeemNote.fundingSource.toString(),
            interestAmount: this.getInterestToRedeem(),
            categoryId: this.redeemNote.redemptionCategoryId,
            categoryHelperText: this.redeemNote.redemptionCategoryHelperText,
          };
          await this.requestNoteRedemption({
            noteId: this.noteId,
            accountId: this.accountId,
            payload: redeemRequest,
          });
          this.loading = false;
          this.$router.push({
            name: 'NoteDetail',
            params: {
              name: this.name,
              noteId: this.noteId,
              userId: this.userId,
            },
          });
        } catch (error) {
          this.loading = false;
          this.setErrorsModalInfo(['There was an error when submitting a request.']);
          this.showErrorsModal();
        }
      },
      async approveRedemption() {
        this.loading = true;
        const redeemRequest = {
          redeemServiceFee: this.getUnformattedValue(this.redeemNote.serviceFee),
          redeemComment: this.redeemNote.comment,
          redemptionCategoryId: this.redeemNote.redemptionCategoryId,
          redemptionCategoryHelperText: this.redeemNote.redemptionCategoryHelperText,
        };
        return this.approveNoteRedemption({
          noteId: this.noteId,
          redeemRequest,
        })
          .then(() => {
            this.loading = false;
            this.$router.push({
              name: 'NoteDetail',
              params: {
                name: this.name,
                noteId: this.noteId,
                userId: this.userId,
              },
            });
          })
          .catch(() => {
            this.loading = false;
            this.setErrorsModalInfo(['There was an error when approving a request.']);
            this.showErrorsModal();
          });
      },
      showRedeemConfirmationModal() {
        this.showQuestionModal({
          title: Constants.redeem.modalTitle,
          question: Constants.redeem.modalQuestion,
          method: async () => {
            try {
              const redeemRequest = {
                comment: this.redeemNote.comment,
              };
              this.loading = true;
              await this.cancelNoteRedemption({
                noteId: this.noteId,
                accountId: this.accountId,
                payload: redeemRequest,
              });
              this.loading = false;
              this.hideQuestionModal();
              this.$router.push({
                name: 'NoteDetail',
                params: {
                  name: this.name,
                  noteId: this.noteId,
                  userId: this.userId,
                },
              });
            } catch (error) {
              this.loading = false;
              this.setErrorsModalInfo(['There was an error when canceling a request.']);
              this.hideQuestionModal();
            }
          },
          yesButtonText: Constants.redeem.modalYesButtonText,
          hideCancelButton: false,
        });
      },
      goBack() {
        this.$router.go(-1);
      },
    },
  };
</script>

<style scoped>
  .line-separator {
    padding: 8px;
    line-height: 1.52857143;
    vertical-align: top;
    border-top: 1px solid #eee;
  }
  .line-separator2 {
    line-height: 2.52857143;
    vertical-align: top;
    width: 49%;
    border-top: 1px solid black;
  }
  .left-margin {
    margin-left: 2%;
  }
  .right-margin {
    margin-left: -4%;
  }
  .top-margin {
    margin-top: 2%;
  }
  .bottom-margin {
    margin-bottom: 1%;
  }
  .space {
    margin-top: 4%;
  }
  .content-heading {
    font-weight: normal;
  }
  .panel-title {
    font-size: 20px;
  }
  .panel-subtitle {
    font-size: 16px;
  }
  .panel-default {
    padding: 30px 40px;
    width: 100%;
  }
  .panel-heading {
    background-color: #ffffff;
    font-size: 16px;
    padding: 0px 5px;
  }
  label {
    color: #888;
    font-size: 14px;
    width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .total-amount {
    font-size: 20px;
  }
  .button-approve {
    background-color: #127285;
  }
  .button-white {
    background-color: white;
    border-color: #127285;
    color: #127285;
  }
  .btn-back {
    color: #31b0d5;
    background-color: Transparent;
    background-repeat: no-repeat;
    border: none;
    cursor: pointer;
    overflow: hidden;
    outline: none;
    padding-left: 20px;
  }
  .icon-back {
    position: relative;
  }
  .icon-back:before {
    content: "\f060";
    font-family: FontAwesome;
    position: absolute;
    left: 0px;
  }
  .radio-item {
    display: inline-block;
    position: relative;
    padding: 0 6px;
  }
  .radio-item input[type='radio'] {
    display: none;
  }
  .radio-item label {
    color: #666;
    font-weight: normal;
    cursor: pointer;
  }
  .radio-item label:before {
    content: " ";
    display: inline-block;
    position: relative;
    top: 0px;
    margin: 0 5px 0 0;
    width: 20px;
    height: 20px;
    border-radius: 11px;
    background-color: transparent;
  }
  .radio-item-unselected label:before {
    border: 2px solid #d3d3d3;
  }
  .radio-item input[type=radio]:checked+label:after {
    border-radius: 11px;
    width: 10px;
    height: 10px;
    position: absolute;
    top: 5px;
    left: 11px;
    content: " ";
    display: block;
  }
  .buttons {
    display: inline-block;
    margin: 5px;
  }
  .tip-alert {
    background-color: #fcf8e3;
    border: 1px solid #faebcc;
    color: #8a6d3b;
    padding: 10px 15px;
    border-radius: 4px;
    margin-top: 10px;
    font-size: 14px;
  }
  .tip-alert i {
    margin-right: 8px;
  }
</style>



// WEBPACK FOOTER //
// Redeem.vue?187fa794